module.exports = __webpack_public_path__ + "static/img/pump.75c91af.png";


//////////////////
// WEBPACK FOOTER
// ./img/project-design/pump.png
// module id = 1029
// module chunks = 1